import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/titleLeft.png'
import _imports_1 from '../assets/img/left-white.png'
import _imports_2 from '../assets/img/titleRight.png'
import _imports_3 from '../assets/img/right-white.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-79e091d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "titlebox" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "title-img"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "title-img"
}
const _hoisted_4 = {
  key: 2,
  src: _imports_2,
  alt: "",
  class: "title-img"
}
const _hoisted_5 = {
  key: 3,
  src: _imports_3,
  alt: "",
  class: "title-img"
}

import { reactive, toRefs, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'title',
  props: {
    title: {
        type: String,
        default: ''
    },
    color: {
        type: String,
        default: ''
    }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.color != 'white')
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : _createCommentVNode("", true),
      (__props.color == 'white')
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("span", {
        class: "title-text",
        style: _normalizeStyle({'color':__props.color
                
            })
      }, _toDisplayString(props.title), 5),
      (__props.color != 'white')
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : _createCommentVNode("", true),
      (__props.color == 'white')
        ? (_openBlock(), _createElementBlock("img", _hoisted_5))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})